// import React, { useState, useEffect } from 'react';
// import { Calendar, Check, X, Clock, User } from 'lucide-react';
// import api from '../../services/api';
// import LoadingSpinner from '../common/LoadingSpinner';
// import { toast } from 'react-toastify';

// const LeaveManagement = ({ onSidebarCountsRefresh }) => {
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState('all');

//   useEffect(() => {
//     fetchLeaves();
//     // eslint-disable-next-line react-hooks/exhaustive-deps -- refetch when status filter changes
//   }, [filter]);

//   const fetchLeaves = async () => {
//     try {
//       const url = filter === 'all' ? '/admin/leaves' : `/admin/leaves?status=${filter}`;
//       const response = await api.get(url);
//       setLeaves(response.data.leaves || []);
//     } catch (error) {
//       console.error('Error fetching leaves:', error);
//       toast.error('Failed to fetch leave applications');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApproveReject = async (leaveId, status, comments = '') => {
//     try {
//       await api.put(`/admin/leave/${leaveId}/approve`, { status, comments });
//       toast.success(`Leave application ${status} successfully!`);
//       fetchLeaves();
//       if (onSidebarCountsRefresh) {
//         onSidebarCountsRefresh();
//       }
//     } catch (error) {
//       const message = error.response?.data?.message || `Failed to ${status} leave application`;
//       toast.error(message);
//     }
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'pending':
//         return 'bg-yellow-100 text-yellow-800';
//       case 'approved':
//         return 'bg-green-100 text-green-800';
//       case 'rejected':
//         return 'bg-red-100 text-red-800';
//       default:
//         return 'bg-gray-100 text-gray-800';
//     }
//   };

//   const filteredLeaves = leaves.filter(leave => {
//     if (filter === 'all') return true;
//     return leave.status === filter;
//   });

//   return (
//     <div className="space-y-6">
//       <div>
//         <h1 className="text-2xl font-bold text-gray-900">Leave Management</h1>
//         <p className="text-gray-600">Review and manage employee leave applications</p>
//       </div>

//       {/* Filter */}
//       <div className="bg-white rounded-lg shadow p-6">
//         <div className="flex space-x-4">
//           <button
//             onClick={() => setFilter('all')}
//             className={`px-4 py-2 rounded-md text-sm font-medium ${
//               filter === 'all'
//                 ? 'bg-primary-100 text-primary-700'
//                 : 'text-gray-500 hover:text-gray-700'
//             }`}
//           >
//             All Leaves
//           </button>
//           <button
//             onClick={() => setFilter('pending')}
//             className={`px-4 py-2 rounded-md text-sm font-medium ${
//               filter === 'pending'
//                 ? 'bg-primary-100 text-primary-700'
//                 : 'text-gray-500 hover:text-gray-700'
//             }`}
//           >
//             Pending
//           </button>
//           <button
//             onClick={() => setFilter('approved')}
//             className={`px-4 py-2 rounded-md text-sm font-medium ${
//               filter === 'approved'
//                 ? 'bg-primary-100 text-primary-700'
//                 : 'text-gray-500 hover:text-gray-700'
//             }`}
//           >
//             Approved
//           </button>
//           <button
//             onClick={() => setFilter('rejected')}
//             className={`px-4 py-2 rounded-md text-sm font-medium ${
//               filter === 'rejected'
//                 ? 'bg-primary-100 text-primary-700'
//                 : 'text-gray-500 hover:text-gray-700'
//             }`}
//           >
//             Rejected
//           </button>
//         </div>
//       </div>

//       {/* Leaves List */}
//       <div className="space-y-4">
//         {loading ? (
//           <LoadingSpinner size="lg" className="py-8" />
//         ) : filteredLeaves.length > 0 ? (
//           filteredLeaves.map((leave) => (
//             <div key={leave._id} className="bg-white rounded-lg shadow p-6">
//               <div className="flex items-start justify-between">
//                 <div className="flex-1">
//                   <div className="flex items-center space-x-3 mb-2">
//                     <div className="flex-shrink-0 h-10 w-10">
//                       <div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center">
//                         <User className="h-5 w-5 text-primary-600" />
//                       </div>
//                     </div>
//                     <div>
//                       <h3 className="text-lg font-medium text-gray-900">
//                         {leave.userId?.name || 'Unknown User'}
//                       </h3>
//                       <p className="text-sm text-gray-500">{leave.userId?.email || 'N/A'}</p>
//                     </div>
//                   </div>
                  
//                   <div className="mt-4 space-y-3">
//                     <div className="flex items-center text-sm text-gray-600">
//                       <Calendar className="h-4 w-4 mr-2 flex-shrink-0" />
//                       <span className="font-medium">
//                         {new Date(leave.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
//                         {new Date(leave.startDate).toDateString() !== new Date(leave.endDate).toDateString() && (
//                           <> to {new Date(leave.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</>
//                         )}
//                       </span>
//                     </div>
                    
//                     {/* Leave Days Breakdown */}
//                     {leave.leaveDays && leave.leaveDays.length > 0 && (
//                       <div className="bg-gray-50 rounded-lg p-3">
//                         <p className="text-xs font-semibold text-gray-600 uppercase mb-2">Days Breakdown:</p>
//                         <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
//                           {leave.leaveDays.map((day, index) => (
//                             <div key={index} className="flex items-center space-x-1 text-xs bg-white rounded px-2 py-1.5 border">
//                               <span className="text-gray-600 font-medium">
//                                 {new Date(day.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
//                               </span>
//                               <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${day.dayType === 'half' ? 'bg-yellow-100 text-yellow-700' : 'bg-blue-100 text-blue-700'}`}>
//                                 {day.dayType === 'half' ? 'Half' : 'Full'}
//                               </span>
//                               <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${
//                                 day.leaveType === 'earned' ? 'bg-green-100 text-green-700' : 
//                                 day.leaveType === 'sick' ? 'bg-pink-100 text-pink-700' :
//                                 day.leaveType === 'casual' ? 'bg-purple-100 text-purple-700' :
//                                 'bg-orange-100 text-orange-700'
//                               }`}>
//                                 {day.leaveType === 'earned' ? 'Earned' : 
//                                  day.leaveType === 'sick' ? 'Sick' : 
//                                  day.leaveType === 'casual' ? 'Casual' : 
//                                  'W/O Pay'}
//                               </span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}
                    
//                     <div className="flex items-center text-sm text-gray-600">
//                       <Clock className="h-4 w-4 mr-2 flex-shrink-0" />
//                       <span>Applied: {new Date(leave.createdAt).toLocaleDateString()}</span>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-700">Reason:</p>
//                       <p className="text-sm text-gray-600 mt-1">{leave.reason}</p>
//                     </div>
//                     {leave.comments && (
//                       <div className="bg-amber-50 border border-amber-200 rounded-lg p-2">
//                         <p className="text-xs font-semibold text-amber-900">Admin Comments:</p>
//                         <p className="text-sm text-amber-800 mt-1">{leave.comments}</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
                
//                 <div className="ml-6 flex flex-col items-end space-y-3">
//                   <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(leave.status)}`}>
//                     {leave.status}
//                   </span>
                  
//                   {leave.status === 'pending' && (
//                     <div className="flex space-x-2">
//                       <button
//                         onClick={() => {
//                           const comments = prompt('Add comments (optional):');
//                           handleApproveReject(leave._id, 'approved', comments);
//                         }}
//                         className="flex items-center px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm"
//                       >
//                         <Check className="h-4 w-4 mr-1" />
//                         Approve
//                       </button>
//                       <button
//                         onClick={() => {
//                           const comments = prompt('Add comments (optional):');
//                           handleApproveReject(leave._id, 'rejected', comments);
//                         }}
//                         className="flex items-center px-3 py-1 bg-red-600 text-white rounded-md hover:bg-red-700 text-sm"
//                       >
//                         <X className="h-4 w-4 mr-1" />
//                         Reject
//                       </button>
//                     </div>
//                   )}
                  
//                   {leave.approvedBy && (
//                     <div className="text-xs text-gray-500">
//                       {leave.status} by {leave.approvedBy?.name || 'Unknown'}
//                       <br />
//                       {new Date(leave.approvedAt).toLocaleDateString()}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="text-center py-8">
//             <Calendar className="mx-auto h-12 w-12 text-gray-400" />
//             <p className="mt-2 text-sm text-gray-500">No leave applications found</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LeaveManagement;

import React, { useState, useEffect } from 'react';
import { Calendar, Check, X, Clock, User, FileText, CheckCircle, History } from 'lucide-react';
import api from '../../services/api';
import LoadingSpinner from '../common/LoadingSpinner';
import { toast } from 'react-toastify';

const LeaveManagement = ({ onSidebarCountsRefresh, compOffOnly = false }) => {
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchLeaves();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refetch when status filter changes
  }, [filter]);

  const fetchLeaves = async () => {
    try {
      const baseUrl = compOffOnly ? '/admin/comp-off' : '/admin/leaves';
      const url = filter === 'all' ? baseUrl : `${baseUrl}?status=${filter}`;
      const response = await api.get(url);
      setLeaves(response.data.leaves || []);
    } catch (error) {
      console.error('Error fetching leaves:', error);
      toast.error(`Failed to fetch ${compOffOnly ? 'Comp Off' : 'leave'} applications`);
    } finally {
      setLoading(false);
    }
  };

  const handleApproveReject = async (leaveId, status, comments = '') => {
    try {
      await api.put(`/admin/leave/${leaveId}/approve`, { status, comments });
      toast.success(`${compOffOnly ? 'Comp Off' : 'Leave'} application ${status} successfully!`);
      fetchLeaves();
      if (onSidebarCountsRefresh) {
        onSidebarCountsRefresh();
      }
    } catch (error) {
      const message = error.response?.data?.message || `Failed to ${status} ${compOffOnly ? 'Comp Off' : 'leave'} application`;
      toast.error(message);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-gray-100 text-gray-600';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  // Rotates through a small palette so avatars aren't all the same color
  const avatarPalette = [
    { bg: 'bg-purple-100', icon: 'text-purple-600' },
    { bg: 'bg-green-100', icon: 'text-green-600' },
    { bg: 'bg-pink-100', icon: 'text-pink-600' },
    { bg: 'bg-blue-100', icon: 'text-blue-600' },
  ];

  const filteredLeaves = leaves.filter(leave => {
    if (filter === 'all') return true;
    return leave.status === filter;
  });

  const filterTabs = [
    { key: 'all', label: compOffOnly ? 'All Comp Off' : 'All Leaves', icon: FileText },
    { key: 'pending', label: 'Pending', icon: Clock },
    { key: 'approved', label: 'Approved', icon: CheckCircle },
    { key: 'rejected', label: 'Rejected', icon: X },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{compOffOnly ? 'Comp Off Management' : 'Leave &amp; Comp Off Management'}</h1>
        <p className="text-gray-600">{compOffOnly ? 'Review, verify, approve, or reject employee Comp Off applications' : 'Review and manage employee leave and Comp Off applications'}</p>
      </div>

      {/* Filter */}
      <div className="flex flex-wrap gap-2">
        {filterTabs.map(({ key, label, icon: Icon }) => {
          const isActive = filter === key;
          return (
            <button
              key={key}
              onClick={() => setFilter(key)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
                isActive
                  ? 'bg-green-600 border-green-600 text-white shadow-sm'
                  : 'bg-white border-gray-300 text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          );
        })}
      </div>

      {/* Leaves List */}
      <div className="space-y-4">
        {loading ? (
          <LoadingSpinner size="lg" className="py-8" />
        ) : filteredLeaves.length > 0 ? (
          filteredLeaves.map((leave, idx) => {
            const avatar = avatarPalette[idx % avatarPalette.length];
            return (
              <div key={leave._id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 md:p-3 relative">
                {leave.status !== 'pending' && (
                  <span className={`absolute top-5 right-5 inline-flex px-3 py-1 text-xs font-bold rounded-full uppercase ${getStatusColor(leave.status)}`}>
                    {leave.status}
                  </span>
                )}

                <div className="flex items-center space-x-3 mb-3">
                  <div className="flex-shrink-0 h-10 w-10">
                    <div className={`h-10 w-10 rounded-full ${avatar.bg} flex items-center justify-center`}>
                      <User className={`h-5 w-5 ${avatar.icon}`} />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-gray-900">
                      {leave.userId?.name || 'Unknown User'}
                    </h3>
                    <p className="text-sm text-gray-500 py-1">{leave.userId?.email || 'N/A'}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center text-sm text-black-600 font-semibold">
                    <Calendar className="h-4 w-4 mr-2 flex-shrink-0" />
                    <span>
                      {new Date(leave.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      {new Date(leave.startDate).toDateString() !== new Date(leave.endDate).toDateString() && (
                        <> to {new Date(leave.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</>
                      )}
                    </span>
                  </div>

                  {/* Leave Days Breakdown */}
                  {leave.leaveDays && leave.leaveDays.length > 0 && (
                    <div className="bg-gray-50 rounded-lg p-3">
                      <p className="text-xs font-bold text-orange-700 uppercase mb-2">Days Breakdown:</p>
                      <div className="grid grid-cols-2 gap-2">
                        {leave.leaveDays.map((day, index) => (
                          <div key={index} className="flex flex-col space-y-1 bg-white rounded-lg px-3 py-2 border border-gray-200">
                            <span className="text-gray-700 font-semibold text-sm">
                              {new Date(day.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                            </span>
                            <div className="flex items-center gap-1.5 flex-wrap">
                              <span className="px-2 py-0.5 rounded text-xs font-bold bg-indigo-100 text-indigo-700">
                                {day.dayType === 'half' ? 'HALF' : 'FULL'}
                              </span>
                              <span className={`px-2 py-0.5 rounded text-xs font-bold ${
                                day.leaveType === 'earned' ? 'bg-green-100 text-green-700' :
                                day.leaveType === 'sick' ? 'bg-pink-100 text-pink-700' :
                                day.leaveType === 'comp_off' ? 'bg-amber-100 text-amber-700' :
                                day.leaveType === 'casual' ? 'bg-purple-100 text-purple-700' :
                                'bg-orange-100 text-orange-700'
                              }`}>
                                {day.leaveType === 'earned' ? 'EARNED' :
                                 day.leaveType === 'sick' ? 'SICK' :
                                 day.leaveType === 'comp_off' ? 'COMP OFF' :
                                 day.leaveType === 'casual' ? 'CASUAL' :
                                 'W/O PAY'}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="flex items-center text-sm text-black-500 italic">
                    <History className="h-4 w-4 mr-2 flex-shrink-0" />
                    <span>Applied: {new Date(leave.createdAt).toLocaleDateString()}</span>
                  </div>

                  <div>
                    <p className="text-sm font-bold text-gray-900">Reason:</p>
                    <p className="text-sm text-blue-700 mt-1">{leave.reason}</p>
                  </div>

                  {leave.comments && (
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-2">
                      <p className="text-xs font-semibold text-amber-900">Admin Comments:</p>
                      <p className="text-sm text-amber-800 mt-1">{leave.comments}</p>
                    </div>
                  )}
                </div>

                {leave.status === 'pending' && (
                  <div className="flex space-x-3 mt-4">
                    <button
                      onClick={() => {
                        const comments = prompt('Add comments (optional):');
                        handleApproveReject(leave._id, 'approved', comments);
                      }}
                      className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-green-700 text-white rounded-lg hover:bg-green-800 text-sm font-semibold"
                    >
                      <Check className="h-4 w-4" />
                      Approve
                    </button>
                    <button
                      onClick={() => {
                        const comments = prompt('Add comments (optional):');
                        handleApproveReject(leave._id, 'rejected', comments);
                      }}
                      className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-white text-red-600 border-2 border-red-500 rounded-lg hover:bg-red-50 text-sm font-semibold"
                    >
                      <X className="h-4 w-4" />
                      Reject
                    </button>
                  </div>
                )}

                {leave.approvedBy && (
                  <div className="text-xs text-gray-500 mt-3">
                    {leave.status} by {leave.approvedBy?.name || 'Unknown'}
                    <br />
                    {new Date(leave.approvedAt).toLocaleDateString()}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-center py-8">
            <Calendar className="mx-auto h-12 w-12 text-gray-400" />
            <p className="mt-2 text-sm text-gray-500">No {compOffOnly ? 'Comp Off' : 'leave'} applications found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveManagement;
